import Header from "./components/Header";
import Footer from "./components/Footer";
import { Outlet } from "react-router-dom";

const AppLayout = () => {

  return (
    <div style={{width : "100%", height : "100%"}}>
        <Header/>
        <Outlet/>
        <Footer/>
    </div>
  )
}

export default AppLayout
